import { NavItemProps } from '../../components/Layout/Nav/NavItem';
import { instance } from '../api/auth';
import { visibleNavItems as data } from '../constants/nav-menu-data';
import { getEnv } from './get-env';

async function navMenuHandler<P extends Omit<NavItemProps, 'item'>>(
    Component: React.FC<NavItemProps>,
    props?: P
) {
    const roleScope = await getEnv('ROLE_SCOPE', true);
    const account = instance.getActiveAccount();

    /* eslint-disable-next-line */
    return data.map((item) => {
        if (item.role) {
            if (
                item.role.some((r) =>
                    account?.idTokenClaims?.roles?.some((userRole: string) => userRole === r)
                )
            )
                return <Component {...props} item={item} key={item.href} />;
        } else {
            if (
                roleScope
                    .split(',')
                    .some((r) => account?.idTokenClaims?.roles?.some((userRole: string) => userRole === r))
            )
                return <Component {...props} item={item} key={item.href} />;
        }
    });
}

export default navMenuHandler;
